import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
import anatomy from './images/anatomy.png';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h2>{`Usage`}</h2>
    <p>{`Use checkbox group to allow users to select multiple items from a list of individual items, or to mark one individual item as selected.`}</p>
    <h3>{`Best practices`}</h3>
    <ul>
      <li parentName="ul">{`Put checkboxes in a logical order`}</li>
      <li parentName="ul">{`If users are only allowed to select a single option, consider using a `}<a parentName="li" {...{
          "href": "/brand/components/RadioGroup"
        }}>{`radio group`}</a>{` instead`}</li>
      <li parentName="ul">{`Each checkbox's state should be independent from other checkboxes in the group. For example: checking one checkbox should not check or disable any other checkboxes`}</li>
    </ul>
    <h2>{`Anatomy`}</h2>
    <img src={anatomy} alt="Anatomy diagram" />
    <p><strong parentName="p">{`Label:`}</strong>{` A title that labels the group of options and helps users understand the relationship between the options in the group.`}</p>
    <p><strong parentName="p">{`Required indicator:`}</strong>{` Indicates that a selection is required.`}</p>
    <p><strong parentName="p">{`Caption:`}</strong>{` May be used to provide additional context about the checkbox group when the label alone is not sufficient`}</p>
    <p><strong parentName="p">{`Options:`}</strong>{` A list of options represented using `}<a parentName="p" {...{
        "href": "/brand/components/Checkbox"
      }}>{`checkboxes`}</a>{`.`}</p>
    <p><strong parentName="p">{`Validation message:`}</strong>{` A message explaining why the selection failed validation. See the `}<a parentName="p" {...{
        "href": "https://primer.style/ui-patterns/forms/overview#validation-message"
      }}>{`form pattern documentation`}</a>{` for more information on form validation patterns.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Once a user checks an option from a checkbox group, the result should not be saved or applied until the user has explicitly submitted their input using a "save" or "submit" button. See the `}<a parentName="p" {...{
        "href": "https://primer.style/ui-patterns/saving"
      }}>{`saving pattern guidelines`}</a>{` for more information.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Checkbox"
        }}>{`Checkbox`}</a>{`: Used to render an individual checkbox control.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/FormControl"
        }}>{`FormControl`}</a>{`: Used to group individual controls with an associated label.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/RadioGroup"
        }}>{`RadioGroup`}</a>{`: Similar to `}<inlineCode parentName="li">{`CheckboxGroup`}</inlineCode>{`, but used for organizing radio controls.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      